
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw } from '../../lib'
// import AsideBar from './AsideBar'

// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function ReportItem(props) {
    const { index, item, openReport, openCallReport, downloadPDF } = props

    const ref = useRef(null)
    const [call, setCall] = useState(item)

    useEffect(() => {
        setCall(item)
    }, [])

    return (
        <tr style={{ color: '#707070', borderBottom: '2px solid rgb(247, 247, 247)' }}>
            <td>{call.id}</td>
            <td>{call.project_name}</td>
            <td>{call.bussiness_key}</td>
            <td>{call.created_date.substring(0, 10)}</td>
            <td>{call.time_call}</td>
            <td>{Number((call.evaluations?.qualification * 100).toFixed(1)) || 0}%</td>
        
            <td style={{backgroundColor: '#F7F7F7'}}>
                <img
                    src={'/icons/view-report-icon.png'}
                    // width="50"
                    height="30"
                    alt="edit"
                    onClick={() => openCallReport(call)}
                />
            </td>
            <td style={{backgroundColor: '#F7F7F7'}}>
                <img
                    src={'/icons/download-report-pdf-icon.png'}
                    height="30"
                    alt="edit"
                    onClick={() => downloadPDF(call.evaluations)}
                />
            </td>
        </tr>



    )
}
